export default __webpack_public_path__ + "static/media/header-img.3bdfab29.svg";